import { type ReactElement, type ReactNode, useState, useEffect, ChangeEvent } from "react"
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "src/app/store";

export interface DealerDetailCardProps {
        children?: ReactNode
}

export default function DealerDetailCard(props: DealerDetailCardProps): ReactElement {

        const { dealerDetailLoading, dealerDetail } = useSelector((state: RootState) => state.dealerDetail);

        return <>
                {
                        !dealerDetailLoading ?
                                <div className="flex flex-col w-full h-full gap-4">
                                        <div className="flex w-full h-full flex-[1_1_50%] gap-4">
                                                <div className="flex flex-col m-4 flex-[1_1_50%] bg-[#00ffff] rounded-md shadow-[4px_4px_10px_rgba(0,0,0,0.25)] justify-around items-center gap-4">
                                                        <div className="text-xs drop-shadow-md italic">
                                                                Dealer Name
                                                        </div>
                                                        <div className="text-xl drop-shadow-md">
                                                                {dealerDetail.DealerName}
                                                        </div>
                                                </div>
                                                <div className="flex flex-col m-4 flex-[1_1_50%] bg-[#00ffff] rounded-md shadow-[4px_4px_10px_rgba(0,0,0,0.25)] justify-around items-center gap-4">
                                                        <div className="text-xs drop-shadow-md italic">
                                                                Doors
                                                        </div>
                                                        <div className="text-xl drop-shadow-md">
                                                                {dealerDetail.TotalNumberOfDoors}
                                                        </div>
                                                </div>
                                        </div>
                                        <div className="flex w-full h-full flex-[1_1_50%] gap-4">
                                                <div className="flex flex-col m-4 flex-[1_1_50%] bg-[#00ffff] rounded-md shadow-[4px_4px_10px_rgba(0,0,0,0.25)] justify-around items-center gap-4">
                                                        <div className="text-xs drop-shadow-md italic">
                                                                Clouds
                                                        </div>
                                                        <div className="text-xl drop-shadow-md">
                                                                {dealerDetail.TotalNumberOfInstances}
                                                        </div>
                                                </div>
                                                <div className="flex flex-col m-4 flex-[1_1_50%] bg-[#00ffff] rounded-md shadow-[4px_4px_10px_rgba(0,0,0,0.25)] justify-around items-center gap-4">
                                                        <div className="text-xs drop-shadow-md italic">
                                                                Locations
                                                        </div>
                                                        <div className="text-xl drop-shadow-md">
                                                                {dealerDetail.TotalNumberOfLocations}
                                                        </div>
                                                </div>
                                        </div>
                                </div>
                                :
                                <></>
                }
        </>
}
